import React from 'react'
import {Link, useMatch, useResolvedPath} from 'react-router-dom'

const NavigationLink = ({destination, title}) => {
    let resolved = useResolvedPath(destination);
    let match = useMatch({ path: resolved.pathname, end: true });

    const className = match  
                    ? 'bg-gray-900 text-white px-3 py-2 rounded-md text-sm font-medium'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium'

    return (
        <Link to={destination} className={className}>{title}</Link>
    )
}

export default NavigationLink
